document.addEventListener('DOMContentLoaded', () => {
  // product section + viewer
  const section =
    document.querySelector('section[id^="MainProduct-"]') ||
    document.querySelector('[id^="MainProduct-"]')?.closest('section') ||
    document;
  const viewer = section.querySelector('[id^="GalleryViewer"]');
  if (!viewer) return;

  // overlay arrows on the big image area
  const wrapper = viewer.closest('.product__media, .product__media-wrapper, .product-media') || viewer;
  wrapper.classList.add('ps-gallery-wrap');

  const nav = document.createElement('div');
  nav.className = 'ps-gallery-nav';
  nav.innerHTML = `
    <button type="button" class="ps-prev" aria-label="Previous image">‹</button>
    <button type="button" class="ps-next" aria-label="Next image">›</button>
  `;
  wrapper.appendChild(nav);

  const viewerId = viewer.id; // e.g., GalleryViewer-template--...__main

  // Build a list of thumbnails scoped to THIS viewer, sorted by data-media-position
  function getThumbEntries() {
    // each li has data-media-position; the button controls the viewer
    const items = Array.from(
      section.querySelectorAll('.thumbnail-list__item.slider__slide, li.slider__slide.thumbnail-list__item')
    );

    // collect (li, button, pos, mediaId)
    let entries = items.map(li => {
      const btn = li.querySelector(`button.thumbnail[aria-controls="${viewerId}"]`);
      if (!btn) return null;
      const posAttr = li.getAttribute('data-media-position');
      const pos = posAttr ? parseInt(posAttr, 10) : NaN;
      const mediaId = li.getAttribute('data-media-id') || btn.getAttribute('data-media-id') || '';
      return { li, btn, pos, mediaId };
    }).filter(Boolean);

    // de-dupe in case the slider makes clones
    const seen = new Set();
    entries = entries.filter(e => {
      const key = e.mediaId || `pos:${e.pos}`;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });

    // sort by the explicit media position; fallback to DOM order
    entries.sort((a, b) => {
      const ap = isNaN(a.pos) ? 1e9 : a.pos;
      const bp = isNaN(b.pos) ? 1e9 : b.pos;
      return ap - bp;
    });

    return entries;
  }

  function activeIndex(entries) {
    let i = entries.findIndex(e => e.btn.getAttribute('aria-current') === 'true');
    if (i !== -1) return i;

    // fallback: match visible slide by data-media-id
    const slide = section.querySelector('.product__media-item.slider__slide[aria-hidden="false"]');
    if (slide) {
      const id = slide.getAttribute('data-media-id') ||
                 slide.querySelector('[data-media-id]')?.getAttribute('data-media-id');
      i = entries.findIndex(e => e.mediaId && e.mediaId === id);
      if (i !== -1) return i;
    }
    return 0;
  }

  function fireClick(el) {
    ['pointerdown', 'mousedown', 'mouseup', 'click'].forEach(evt =>
      el.dispatchEvent(new MouseEvent(evt, { bubbles: true }))
    );
  }

  function go(delta) {
    const entries = getThumbEntries();
    if (!entries.length) return;
    const i = activeIndex(entries);
    const next = (i + delta + entries.length) % entries.length;
    fireClick(entries[next].btn); // identical to a user clicking that thumbnail
  }

  // Only show arrows when there's more than one image
function updateVisibility() {
  const entries = (typeof getThumbEntries === 'function') ? getThumbEntries() : [];
  nav.style.display = entries.length > 1 ? '' : 'none';
}
updateVisibility();

// Recalculate when the thumbnail list changes (variant switch, filtering, etc.)
const thumbRoot = section.querySelector('thumbnail-slider, .thumbnail-list, .thumbnail-slider');
if (thumbRoot && 'MutationObserver' in window) {
  const mo = new MutationObserver(() => updateVisibility());
  mo.observe(thumbRoot, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-current', 'data-media-id', 'hidden']
  });
}


wrapper.setAttribute('tabindex', '0');
wrapper.addEventListener('keydown', (e) => {
  if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
  if (e.key === 'ArrowLeft')  { e.preventDefault(); go(-1); }
});


nav.querySelector('.ps-next').addEventListener('click', e => {
  e.preventDefault();
  go(1);
  updateVisibility();
});
nav.querySelector('.ps-prev').addEventListener('click', e => {
  e.preventDefault();
  go(-1);
  updateVisibility();
});

});
(() => {
  // ---- helpers ----
  const $  = (s, r=document) => r.querySelector(s);
  const $$ = (s, r=document) => Array.from(r.querySelectorAll(s));
  const isVisible = el => !!(el && !el.hidden && el.offsetParent !== null);

  // Avoid duplicate binding across re-renders
  if (window.__PS_GALLERY_NAV_BOUND__) return;

  // Active thumb button anywhere on page
  const getActiveBtn = () => $('button.thumbnail[aria-current="true"]');
  // <li> wrapper for a thumb
  const getThumbLI   = (btn) => btn?.closest('li.thumbnail-list__item');

  // Next/prev *visible* thumb within same <ul>
  const findNextVisibleBtn = (li) => {
    for (let n = li?.nextElementSibling; n; n = n.nextElementSibling) {
      const b = n.querySelector('button.thumbnail');
      if (isVisible(b)) return b;
    }
    return null;
  };
  const findPrevVisibleBtn = (li) => {
    for (let n = li?.previousElementSibling; n; n = n.previousElementSibling) {
      const b = n.querySelector('button.thumbnail');
      if (isVisible(b)) return b;
    }
    return null;
  };

  // Toggle disabled state
  const setDisabled = (el, on) => {
    el.classList.toggle('is-disabled', on);
    el.setAttribute('aria-disabled', on ? 'true' : 'false');
    if ('disabled' in el) el.disabled = !!on;
  };

  const updateArrows = () => {
    const prevBtn = $('.ps-prev');
    const nextBtn = $('.ps-next');
    if (!prevBtn || !nextBtn) return;

    const active = getActiveBtn();
    const li = getThumbLI(active);

    const hasPrev = !!findPrevVisibleBtn(li);
    const hasNext = !!findNextVisibleBtn(li);

    setDisabled(prevBtn, !hasPrev);
    setDisabled(nextBtn, !hasNext);
  };

  // Navigation that cannot double-fire
  const goPrev = () => {
    const li = getThumbLI(getActiveBtn());
    const prev = findPrevVisibleBtn(li);
    if (prev) prev.click();
    requestAnimationFrame(updateArrows);
  };
  const goNext = () => {
    const li = getThumbLI(getActiveBtn());
    const next = findNextVisibleBtn(li);
    if (next) next.click();
    requestAnimationFrame(updateArrows);
  };

  // Wait for arrows + any thumbnail to exist, then bind ONCE
  const boot = new MutationObserver(() => tryInit());
  function tryInit(){
    const prev = $('.ps-prev');
    const next = $('.ps-next');
    const anyThumb = $('button.thumbnail');
    if (!prev || !next || !anyThumb) return;

    // prevent duplicate bindings
    if (window.__PS_GALLERY_NAV_BOUND__) return;
    window.__PS_GALLERY_NAV_BOUND__ = true;

    // Capture phase + stopImmediatePropagation to block any other handlers
    prev.addEventListener('click', (e) => {
      e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
      goPrev();
    }, true);
    next.addEventListener('click', (e) => {
      e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
      goNext();
    }, true);

    // Update when active thumb changes or thumbs show/hide
    const mo = new MutationObserver(() => setTimeout(updateArrows, 0));
    mo.observe(document.documentElement, {
      subtree: true, childList: true, attributes: true,
      attributeFilter: ['aria-current','hidden','style','class']
    });

    window.addEventListener('resize', () => setTimeout(updateArrows, 0));
    window.addEventListener('load', updateArrows);

    requestAnimationFrame(updateArrows);
    boot.disconnect();
  }
  boot.observe(document.documentElement, { subtree:true, childList:true });
  // Try immediately as well
  tryInit();
})();

// Ensure gallery arrows live inside the GalleryViewer so they position over the image
(() => {
  const placeNav = () => {
    const viewer =
      document.querySelector('slider-component[id^="GalleryViewer-"]') ||
      document.querySelector('[id^="GalleryViewer-"]');
    const nav = document.querySelector('.ps-gallery-nav');
    if (viewer && nav && !viewer.contains(nav)) viewer.appendChild(nav);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeNav);
  } else {
    placeNav();
  }

  // If the product section re-hydrates or variant swaps re-render the gallery,
  // keep the nav inside the viewer.
  new MutationObserver(placeNav).observe(document.body, { childList: true, subtree: true });
})();
